import { type Channels, initRemoteLoginSDK } from '@eureka/shared/src/login-sdk';
import type { I18n } from 'vue-i18n';
import _ from 'lodash';
import { track, SELF_ENTRY_CHANNEL } from '@eureka/shared/src/utils/track';

export function initLoginSdk(i18n: I18n, channels: Channels = {}) {
    const openLoginDialog = async (withoutClose = false, customChannels?: Channels) => {
        track({
            event_type: 'ss_plg_register',
            source_type: 'register_exposure',
            event_detail_str: JSON.stringify({
                registrationSource: SELF_ENTRY_CHANNEL,
            }),
        });

        const { openLoginDialog } = await initRemoteLoginSDK();

        await openLoginDialog({
            channels: _.assign({}, channels, customChannels),
            withoutClose,
            onClickRegister: (method: any) => {
                try {
                    track({
                        event_type: 'ss_plg_register',
                        source_type: 'register_click',
                        event_detail_str: JSON.stringify({
                            registrationSource: SELF_ENTRY_CHANNEL,
                            registrationMethod: method,
                        }),
                    });
                } catch (error) {
                    console.log('Failed to track registration click event:', error);
                }
            },
        }).catch((error) => {
            if(error?.type === 'close') {
                track({
                    event_type: 'ss_plg_register',
                    source_type: 'register_close',
                    event_detail_str: JSON.stringify({
                        registrationSource: SELF_ENTRY_CHANNEL,
                    }),
                });
            }
            throw error;
        });

        if (window.__reinitializeApp) {
            await window.__reinitializeApp();
        } else {
            window.location.reload();
        }
    };

    const handleThirdPartyLoginErrors = () => {
        initRemoteLoginSDK()
            .then(({ initSDK }) => {
                initSDK();
            });
    };

    return {
        openLoginDialog,
        handleThirdPartyLoginErrors,
    };
}
